import React from "react";

const Otherskills =() =>{
return (
    <>
    <div className="skillsContainer" id="skillscontainer">
        <div className="skills">
        <h5>Leadership</h5>
        </div>
        <div className="skills">
        <h5>Team work</h5>
        </div>
        <div className="skills">
        <h5>Emotional Intelligence</h5>
        </div>
        <div className="skills">
        <h5>Problem Solving</h5>
       </div> 
    </div>
    </>
    
)
}


export default Otherskills;